import React, { useState } from 'react';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './components/dashboard/Dashboard';
import { AssetManagement } from './components/pages/AssetManagement';
import { AIReminders } from './components/pages/AIReminders';
import { Maintenance } from './components/pages/Maintenance';
import { Contracts } from './components/pages/Contracts';
import { AIRecommendations } from './components/pages/AIRecommendations';
import { Analytics } from './components/pages/Analytics';
import { UserManagement } from './components/pages/UserManagement';
import { ServerStatus } from './components/pages/ServerStatus';
import { Audit } from './components/pages/Audit';
import { Notifications } from './components/pages/Notifications';
import { Reporting } from './components/pages/Reporting';
import { TaskBoard } from './components/pages/TaskBoard';
import { UserRole, ROLE_ACCESS } from './types/auth';
export function App() {
  const [activePage, setActivePage] = useState('dashboard');
  // Get user info from localStorage
  const userRole = (localStorage.getItem('userRole') || 'user') as UserRole;
  const userName = localStorage.getItem('userName') || 'User';
  const userUnit = localStorage.getItem('userUnit') || '';
  // RBAC guard: ensure activePage is allowed for the current role
  const allowedPages = ROLE_ACCESS[userRole] || [];
  const safePage = allowedPages.includes(activePage) ? activePage : 'dashboard';
  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    localStorage.removeItem('userUnit');
    window.location.href = '/login';
  };
  const renderPage = () => {
    switch (safePage) {
      case 'dashboard':
        return <Dashboard data-id="element-0" />;
      case 'assets':
        return <AssetManagement data-id="element-1" />;
      case 'reminders':
        return <AIReminders data-id="element-2" />;
      case 'maintenance':
        return <Maintenance data-id="element-3" />;
      case 'contracts':
        return <Contracts data-id="element-4" />;
      case 'recommendations':
        return <AIRecommendations data-id="element-5" />;
      case 'analytics':
        return <Analytics data-id="element-6" />;
      case 'users':
        return <UserManagement data-id="element-7" />;
      case 'server':
        return <ServerStatus data-id="element-8" />;
      case 'audit':
        return <Audit data-id="element-9" />;
      case 'notifications':
        return <Notifications data-id="element-10" />;
      case 'reporting':
        return <Reporting data-id="element-11" />;
      case 'taskboard':
        return <TaskBoard data-id="element-12" />;
      default:
        return <Dashboard data-id="element-13" />;
    }
  };
  return <Layout activePage={safePage} setActivePage={setActivePage} onLogout={handleLogout} userRole={userRole} userName={userName} userUnit={userUnit} data-id="element-14">
      {renderPage()}
    </Layout>;
}